import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4db9c79e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-input-group-wrapper" }
const _hoisted_2 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_3 = {
  key: 0,
  class: "ant-input-group-addon",
  style: {"padding":"0px","background-color":"transparent","border":"none!important"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "ant-skeleton ant-skeleton-active css-eq3tly"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-skeleton-content" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "ant-skeleton-paragraph" }, [
    /*#__PURE__*/_createElementVNode("li")
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        (!_ctx.props.varios)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              (!_ctx.props.varios)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    ((_ctx.UtilitarioGeral.valorValido(_ctx.state.detalhe.logoBanco) && _ctx.state.detalhe.tipoConta === _ctx.ETipoConta.ContaPoupanca) || (_ctx.UtilitarioGeral.valorValido(_ctx.state.detalhe.logoBanco) && _ctx.state.detalhe.tipoConta === _ctx.ETipoConta.ContaCorrente))
                      ? (_openBlock(), _createBlock(_component_a_image, {
                          key: 0,
                          src: _ctx.state.detalhe.logoBanco,
                          preview: false,
                          style: {"width":"50px","border-radius":"4px"}
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock(_component_icone, {
                          key: 1,
                          class: "ss-icone",
                          style: 'color: #a0aec1;padding: 8px;background-color: #ebeff2;border-radius: 3px;',
                          nome: _ctx.state.icone
                        }, null, 8, ["nome"]))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_form_item, {
          label: _ctx.props.title,
          class: "ss-margin-campos ss-selecionar-conta",
          rules: [{ required: _ctx.props.required }]
        }, {
          default: _withCtx(() => [
            (_ctx.aguardarConclusaoCarregamento(_ctx.computedCodigoSelecionado,_ctx.computedCodigosSelecionados))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : (_openBlock(), _createBlock(_component_a_select, {
                  key: 1,
                  mode: _ctx.props.varios?'multiple':null,
                  value: _ctx.props.varios?_ctx.computedCodigosSelecionados:_ctx.computedCodigoSelecionado,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.props.varios?_ctx.computedCodigosSelecionados = $event:_ctx.computedCodigoSelecionado = $event)),
                  onChange: _ctx.change,
                  onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pesquisarConta(''))),
                  onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pesquisarConta($event))),
                  onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selecionarBase.emDigitacao = false)),
                  "show-search": "",
                  optionFilterProp: "label",
                  class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
                  allowClear: _ctx.props.limparSelecao,
                  placeholder: _ctx.props.placeholder,
                  filterOption: false,
                  "not-found-content": _ctx.selecionarBase.buscandoDados ? undefined : null,
                  options: _ctx.selecionarBase.listaOpcoes,
                  disabled: _ctx.props.disabled,
                  title: _ctx.props.title,
                  "data-coluna": _ctx.props.dataAttributeColuna
                }, _createSlots({ _: 2 }, [
                  (_ctx.selecionarBase.buscandoDados)
                    ? {
                        name: "notFoundContent",
                        fn: _withCtx(() => [
                          _createTextVNode(" Buscando Contas "),
                          _createVNode(_component_a_spin)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["mode", "value", "onChange", "class", "allowClear", "placeholder", "not-found-content", "options", "disabled", "title", "data-coluna"]))
          ]),
          _: 1
        }, 8, ["label", "rules"])
      ])
    ])
  ]))
}